import QRcode from './components/QRcode.vue';

// Named export
export {
  QRcode
}

// Default export
export default {
  QRcode
};